/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import useIsMobile from '../../../hooks/useIsMobile';

import YearFilter from '../../../components/SearchFilters/filters/YearFilter';
import LengthFilter from '../../../components/SearchFilters/filters/LengthFilter';
import FeaturesFilter from '../../../components/SearchFilters/filters/FeaturesFilter';
import CategoryTypeFilter from '../../../components/SearchFilters/CategoryTypeFilter/CategoryTypeFilter';

import { LISTING_CATEGORY } from '../../../constants/listing.constants';

const SecondaryFilters = props => {
  const { renderPriceComponent } = props;

  const isMobile = useIsMobile();
  const [activeDrawer, setActiveDrawer] = useState(null);

  const toggleDrawer = name => {
    if (!isMobile) return;

    setActiveDrawer(prev => {
      if (prev === name) {
        // clicking the same drawer → close it
        return null;
      }

      // clicking another drawer
      return name;
    });
  };

  const shouldRender = name => {
    if (!isMobile) return true;
    if (activeDrawer === null) return true;
    return activeDrawer === name;
  };

  return (
    <>
      {shouldRender('category') && (
        <CategoryTypeFilter
          onToggle={() => toggleDrawer('category')}
          categoryOptions={Object.values(LISTING_CATEGORY)}
        />
      )}

      {shouldRender('price') &&
        renderPriceComponent({
          onToggle: () => toggleDrawer('price'),
        })}

      {shouldRender('length') && <LengthFilter onToggle={() => toggleDrawer('length')} />}

      {shouldRender('year') && <YearFilter onToggle={() => toggleDrawer('year')} />}

      {shouldRender('features') && <FeaturesFilter onToggle={() => toggleDrawer('features')} />}
    </>
  );
};

export default SecondaryFilters;
